function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.504 3.5a.498.498 0 00-.705 0L4.354 8.94V6.147c0-.275-.225-.5-.5-.5s-.5.225-.5.5v4c0 .275.225.5.5.5h4c.275 0 .5-.225.5-.5s-.225-.5-.5-.5H5.059L10.504 4.2c.19-.19.19-.51 0-.7z",
  fill: "currentColor"
});

var SvgReceive = function SvgReceive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgReceive;